<template>
  <div id="package-creation-services">
    <item-tile
      v-for="(service, index) in subject.services"
      :key="index"
      :heading="service.name"
      :selected="true"
      @click="removeService(service)"
    />
    <item-tile
      v-for="(service, index) in services"
      :key="index"
      :selected="false"
      :heading="service.name"
      @click="addService(service)"
    />
  </div>
</template>
<script>
import ItemTile from "../../../../../../Components/UI/ItemTile.vue";
export default {
  computed: {
    services() {
      return this.$store.getters.services.filter((x) => {
        return !this.subject.services.includes(x);
      });
    },
  },
  methods: {
    addService(service) {
      this.$emit("addService", service);
    },
    removeService(service) {
      this.$emit("removeService", service);
    },
  },
  components: {
    ItemTile,
  },
  props: ["subject"],
};
</script>
<style scoped>
#package-creation-services {
  display: flex;
  overflow: scroll;
  padding: 25px;
}
</style>
